// extracted by mini-css-extract-plugin
export default {"Pagehead":"RestrictionsPanel-module__Pagehead--P1B27"};